module.exports = __webpack_public_path__ + "img/currency-guide-1.8eab7988.png";